<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <div class="row">
    <div class="col-sm" style="height: 10px;"></div>
    <div class="col-md" style="height: 20px"></div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb" class="bread-styles">
          <ol class="breadcrumb bd-background">
            <li class="breadcrumb-item active" aria-current="page">
                <a routerLink="#"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp;  > &nbsp;
              <a style="color: #6c757d;text-decoration: none;"> <span style="color: #337ab7;font-family: 'pt_sans_captionbold';">Whishlists</span></a>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="pie-charts">
        
      <h4 style="text-align: center;"> CREATE Whishlist </h4>
      <hr>

      <form role="form" class="form-styles" #myForm="ngForm">
        <div class="form-group">
          <div class="form-row">
            <div class="col-md-6">
                <label for="exampleFormControlTextarea1">Add Whishlist</label>
                <textarea class="form-control rounded-0" id="exampleFormControlTextarea1" name="username" 
                data-toggle="tooltip" id="username" [(ngModel)]="wishlist_input_field"
                pattern="^(([0-9]{1,3}\.){2}(?:(?=(\d{1,3}\.))(\d{1,3}\.\d{1,3}|\d{1,3}\.(\*){1})|(\*\.\*)|(\*){1})\,{0,1})+$"
                ngModel #mobileref="ngModel" > </textarea>
                <div *ngIf="mobileref.errors &&(mobileref.touched || mobileref.dirty)" class="alert alert-danger">
                    <div [hidden]="!mobileref.errors?.pattern">
                        Pattern Should be ( 192.168.1.1) or (192.1.1.*)
                    </div>
                </div>
            </div>
                <div class="col-md">
                        <label style="color: transparent;"> <sup class="error">.</sup></label>
                    <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block" tabIndex="9" value="Submit"
                        (click)="submit()">
                </div>
                <div class="col-md">
                        <!-- <label style="color: transparent;"> <sup class="error">.</sup></label>
                    <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block" tabIndex="9" value="Reset"
                        (click)="reset()"> -->
                </div>

          </div>
        </div>
      </form>
    </div>
  </div>

</section>